// cookiebot-callback.service.ts
import { Injectable } from '@angular/core';
import { AnalyticsService } from '../adobe-analytics/analytics.service';

declare global {
  interface Window {
    Cookiebot: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class CookiebotCallbackService {
  constructor(private analyticsService: AnalyticsService) {}

  onAccept() {
    if (window.Cookiebot && window.Cookiebot.consent) {
      const consent = window.Cookiebot.consent;
      if (consent.necessary && consent.statistics) {
        this.analyticsService.injectAdobeLaunchScript();
      }
    }
  }

  onDecline() {
    console.log('Usuario rechazó las cookies');
  }

  onDialogInit() {
    console.log('Diálogo de Cookiebot inicializado');
  }

  onDialogDisplay() {
    console.log('Diálogo de Cookiebot mostrado');
  }

  onTagsExecuted() {
    console.log('Etiquetas de Cookiebot ejecutadas');
  }
}
